module.exports = __webpack_public_path__ + "img/icon-data.5051bddc.png";